/**
 * Thousands separator for monetary amounts.
 *
 * Amounts used to be rendered by `toFixed` alone, which produces "235146.79":
 * past a few thousand the figure is hard to read at a glance, and the balance
 * card is the first thing shown on the Trading Journal.
 *
 * The grouping is always the Italian one (dot for thousands, comma for
 * decimals) regardless of the interface language, so the same amount reads the
 * same way to every user. `it-IT` is passed explicitly rather than the active
 * language for exactly that reason: with the browser locale an English user
 * would get "235,146.79" and the two languages would disagree.
 */
const AMOUNT_LOCALE = 'it-IT';

/**
 * Formats a number with thousands separators and a fixed number of decimals.
 *
 * @param value - The number to format
 * @param decimals - Digits after the decimal separator (default 2)
 * @returns The grouped string, e.g. 235146.79 -> "235.146,79"
 */
export function formatAmount(value: number, decimals: number = 2): string {
    if (!Number.isFinite(value)) {
        return '--';
    }

    return value.toLocaleString(AMOUNT_LOCALE, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
        // Senza questo, `it-IT` lascia i numeri di quattro cifre senza
        // separatore ("1430,71" contro "235.146,79"): il raggruppamento
        // comparirebbe solo oltre le diecimila e due importi vicini
        // verrebbero scritti in due modi diversi.
        useGrouping: true,
    });
}
